import React from 'react'
import { ListIconBoxItem as OriginalListIconBoxItem } from '@next-nx/shared-ui/molecules'
import { ListIconBoxItemSettings } from './ListIconBoxItemSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  icon: null,
  helpText: '',
}

export const ListIconBoxItem = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const { icon, helpText } = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-list-icon-box-item ' + props.className}
      >
        <OriginalListIconBoxItem
          item={{
            name: children.props.children[0],
            description: helpText,
            style: icon
          }}
          editMode={enabled}
        />
      </div>
    );
  },
  defaultProps
);

ListIconBoxItem.craft = withCraft({
  name: 'ListIconBoxItem',
  defaultProps: defaultProps,
  settings: ListIconBoxItemSettings,
});
